import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["display", "color", "cursor"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles/common.module.css';
import displayStyles from './styles/display.module.css';
import filterColors from './styles/filters.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const createIconFromImg = (iconName, iconLink) => {
  const Icon = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
        display = 'inline-block',
        color = 'icon-secondary-default',
        cursor = 'default'
      } = props,
      imgProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({}, imgProps), {}, {
      ref: ref,
      src: iconLink,
      alt: iconName,
      className: clsx(styles['container'], styles["cursor_".concat(cursor)], displayStyles["display_".concat(display)], filterColors["filter_".concat(color)]),
      "aria-hidden": "true"
    }));
  });
  Icon.displayName = iconName;
  return Icon;
};